/** Case/whitespace-insensitive email comparison, mirroring the server's binding check. */
export function emailsMatch(a: string, b: string): boolean {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}

/**
 * The `redirect` value passed to the sign-in routes so a provider who signs
 * in (or switches accounts) from the invite page lands back here with the
 * same token — see `parseRedirectTarget` for how the sign-in page splits
 * this back into `to` + `search`. The token rides in the URL because it's the
 * only place it lives (no session stash); it's harmless on its own.
 */
export function buildProviderInviteRedirect(token: string): string {
  return `/provider-invite?${new URLSearchParams({ token }).toString()}`;
}
